import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { PollingData } from '@rd/types';
import { Observable } from 'rxjs';
import { getPollingData, getPollingDataByOrderId } from './polling.selector';

@Injectable({
  providedIn: 'root',
})
export class PollingFacade {
  constructor(private store: Store) {}

  data$ = this.store.select(getPollingData);

  getPolling(orderId: string): Observable<PollingData | undefined> {
    return this.store.select(getPollingDataByOrderId(orderId));
  }
}
